import { getAuthSelfQueryOptions } from '@api/endpoints/auth/get-auth-self'
import type { RolePublic } from '@api/endpoints/auth/get-auth-self-schema'
import type { QueryClient } from '@tanstack/react-query'

function hasWorkspace(roles: RolePublic[], workspaceId: string) {
  return roles.some((role) => role.workspaceId === workspaceId)
}

export async function canAccessWorkspace(
  queryClient: QueryClient,
  workspaceId: string
) {
  const { roles } = await queryClient.ensureQueryData(getAuthSelfQueryOptions())
  if (hasWorkspace(roles, workspaceId)) return true

  const fresh = await queryClient.fetchQuery({
    ...getAuthSelfQueryOptions(),
    staleTime: 0,
  })
  return hasWorkspace(fresh.roles, workspaceId)
}
